import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { crossDomainNavigation } from '../../redux/modules/app';
import { changeLanguage } from 'kodyl-js/i18n/redux';
import { logout } from '../../redux/modules/auth';
import NavUserLogin from './nav-user-login';
import FacebookLoginButton from '../../common/facebook-login/button';
import Dropdown, {
  DropdownTrigger,
  DropdownContent
} from 'react-simple-dropdown';
import Badge from '../../common/badge';
import { browserHistory } from 'react-router';

// TODO: Make md5 hash on the server, under the user object
const gravatarHash = 'afc543b2c57016f8ffc441c769457ab0';

@connect(
  ({
    auth: { user },
    subscriptions: { subscriber },
    i18n: { lang: language }
  }) => ({ user, subscriber, language }),
  { crossDomainNavigation, changeLanguage, logout }
)
@i18n
class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userOpen: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.language !== nextProps.language) {
      return true;
    }
    if (this.props.user !== nextProps.user) {
      return true;
    }
    if (this.state.userOpen !== nextState.userOpen) {
      return true;
    }
    return false;
  }

  changeLanguage = lang => ev => {
    ev.preventDefault();

    if (!__DEV__) {
      this.props.crossDomainNavigation();
      const loc = global.location;
      const path = `${loc.pathname}${loc.search}${loc.hash}`;
      global.location.href = `${loc.protocol}//${loc.hostname.replace(
        /^[^.]+/,
        lang === 'da' ? 'www' : lang
      )}${path}`;
    } else {
      this.props.changeLanguage({ lang });
    }
  };

  logout = () => {
    this.props.logout();
    browserHistory.replace('/login');
  };

  render() {
    const { user, subscriber, language } = this.props;
    const { userOpen } = this.state;

    return (
      <Navbar className="navbar-static-top nav-pri">
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/" className="navbar-brand">
              <span className="fa-stack fa-lg">
                <i className="fa fa-circle fa-stack-2x" />
                <i className="fa fa-home fa-stack-1x fa-inverse" />
              </span>
              <b>
                Bolig
                <span className="inverted">ninja</span>
                .dk
              </b>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse className="navbar-right">
          {!user ? (
            <div className="navbar-nav navbar-left">
              <Link to="/signup" className="btn btn-primary navbar-btn">
                <i className="fa fa-user" />
                {this.i18n('Create profile')}
              </Link>
            </div>
          ) : null}
          {!user ? (
            <div className="nav navbar-nav navbar-left">
              <Dropdown
                className={`account-dropdown${userOpen ? ' open' : ''}`}
                onShow={() => this.setState({ userOpen: true })}
                onHide={() => this.setState({ userOpen: false })}
              >
                <DropdownTrigger className="dropdown-toggle nav-item-profile">
                  <img
                    src={`//www.gravatar.com/avatar/${gravatarHash}?s=24&d=mm`}
                    width="24"
                    height="24"
                  />
                  {this.i18n('My profile')}
                  <b className="caret" />
                </DropdownTrigger>
                <DropdownContent className="dropdown-menu">
                  <div
                    className="mega-dropdown"
                    title="Dropdown"
                    id="basic-nav-dropdown"
                  >
                    <div className="row">
                      <div className="col-sm-6">
                        <NavUserLogin />
                        <Link to="/reset-password">
                          {this.i18n('Forgot password?')}
                        </Link>
                      </div>
                      <div className="col-sm-6">
                        <hr className="visible-xs" />
                        <Link
                          to="/signup"
                          className="btn btn-block btn-primary"
                        >
                          <i className="fa fa-user" />
                          {this.i18n('Create profile')}
                        </Link>
                        <hr style={{ margin: '10px' }} />
                        <FacebookLoginButton />
                      </div>
                      <div className="ruler-vertical" />
                    </div>
                  </div>
                </DropdownContent>
              </Dropdown>
            </div>
          ) : (
            <Nav>
              <NavDropdown
                eventKey={2}
                title={
                  <span className="nav-item-profile">
                    <img
                      src={`//www.gravatar.com/avatar/${gravatarHash}?s=24&d=mm`}
                      width="24"
                      height="24"
                    />
                    {this.i18n('My profile')}
                    <Badge />
                  </span>
                }
                id="nav-profile-dropdown"
              >
                <MenuItem header>{user.name}</MenuItem>
                <IndexLinkContainer to="/profile">
                  <MenuItem eventKey={2.1}>
                    {this.i18n('Edit profile')}
                    <Badge />
                  </MenuItem>
                </IndexLinkContainer>
                <LinkContainer to="/profile/boligagent">
                  <MenuItem eventKey={2.1}>{this.i18n('BoligAgent')}</MenuItem>
                </LinkContainer>
                {subscriber ? (
                  <LinkContainer to="/profile/tenant">
                    <MenuItem className="tenant-ad-link" eventKey={2.2}>
                      {this.i18n('Tenant ad')}
                    </MenuItem>
                  </LinkContainer>
                ) : (
                  <LinkContainer to="/profile/subscription">
                    <MenuItem eventKey={2.2}>{this.i18n('Tenant ad')}</MenuItem>
                  </LinkContainer>
                )}
                {subscriber ? (
                  <LinkContainer to="/profile/subscription">
                    <MenuItem className="subscription-link" eventKey={2.3}>
                      {this.i18n('Subscription')}
                    </MenuItem>
                  </LinkContainer>
                ) : null}
                <MenuItem divider />
                <MenuItem eventKey={2.4} onClick={this.logout}>
                  {this.i18n('Log out')}
                </MenuItem>
              </NavDropdown>
            </Nav>
          )}
          <Nav>
            <NavDropdown
              eventKey={3}
              title={<i className={`flag flag-${language}`} />}
              id="nav-language-dropdown"
            >
              <MenuItem header>{this.i18n('Language')}</MenuItem>
              <LinkContainer
                to={{ pathname: 'https://www.boligninja.dk' }}
                onClick={this.changeLanguage('da')}
              >
                <MenuItem eventKey={3.1}>
                  <i className="flag flag-da" />
                  {this.i18n('Danish')}
                </MenuItem>
              </LinkContainer>
              <LinkContainer
                to={{ pathname: 'https://en.boligninja.dk' }}
                onClick={this.changeLanguage('en')}
              >
                <MenuItem eventKey={3.2}>
                  <i className="flag flag-en" />
                  {this.i18n('English')}
                </MenuItem>
              </LinkContainer>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Navigation;
